import '@popperjs/core';
import 'bootstrap';
import 'htmx.org';

window.htmx = require('htmx.org');